var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectCategory2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  stroke: "#D9D9D9",
  rx: 5.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9D9D9D",
  d: "M3.5 4.75 6 7.25l2.5-2.5"
})));
export default SvgIconSelectCategory2;